import { render, staticRenderFns } from "./PaymentUploads.vue?vue&type=template&id=dd0e80ea&scoped=true&web=true&"
import script from "./PaymentUploads.vue?vue&type=script&lang=ts&"
export * from "./PaymentUploads.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentUploads.vue?vue&type=style&index=0&id=dd0e80ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd0e80ea",
  null
  
)

export default component.exports